function applySwatchImages(container) {
  const scope = container || document;
  scope.querySelectorAll('.bls__option-swatch-js, .bls__option-swatch').forEach(function(swatch) {
    if (swatch.dataset.swatchApplied) return;
    const img = swatch.dataset.image;
    if (img) {
      swatch.style.backgroundImage = 'url(' + img + ')';
      swatch.style.backgroundSize = 'cover';
      swatch.style.backgroundPosition = 'center';
      swatch.style.backgroundColor = 'transparent';
    }
    swatch.dataset.swatchApplied = 'true';
  });
}

document.addEventListener('DOMContentLoaded', applySwatchImages);
setTimeout(applySwatchImages, 500);

const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    mutation.addedNodes.forEach(function(node) {
      if (node.nodeType === 1) applySwatchImages(node);
    });
  });
});
observer.observe(document.body, { childList: true, subtree: true });

document.addEventListener('click', function(e) {
  const swatch = e.target.closest('.bls__option-swatch-js, .bls__option-swatch');
  if (!swatch) return;

  const img = swatch.dataset.image;
  if (!img) return;

  // Collection card
  const card = swatch.closest('.bls__grid__item');
  if (card) {
    const cardImg = card.querySelector('img');
    if (cardImg) {
      cardImg.src = img;
      if (cardImg.srcset) cardImg.srcset = '';
    }
    return;
  }

  // Product page — swap main gallery image
  const galleryImg = document.querySelector(
    '.bls__product-media img, .product__media img, .bls__media-gallery img, [class*="product-media"] img'
  );
  if (galleryImg) {
    galleryImg.src = img;
    if (galleryImg.srcset) galleryImg.srcset = '';
  }
});
